import { useEffect, useState } from "react";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Form from "../../components/common/Form/From";
import rightImage from "../../resources/images/user_rightIcon.svg";
import logo from "../../resources/images/ats-blue.svg";
import styles from "./Login.module.scss";
import ForgotPasswordForm from "../../components/ForgotPassword/ForgotPasswordForm";
import { authActions } from "../../actions/auth.actions";
import { toast } from "react-toastify";

const ForgotPasswordPage = () => {
  let { token } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    password: "",
    cpassword: "",
  });
  const [submited, setSubmited] = useState(false);
  const [uData, setUData] = useState("")
  const dispatch = useDispatch();
  const tokenUser = useSelector((state) => state.authentication.tokenUser);
  useEffect(() => {
    if (token) {
        dispatch(authActions.checkToken(token))
    }
}, [])
useEffect(() => {
  if (tokenUser) {
      setUData(tokenUser)
  }
}, [tokenUser])
  const ForgotSchema = yup.object().shape({
    password: yup
      .string()
      .max(15, "Too Long!")
      .required("Password is required"),
    cpassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match"),
  });

  const handleSubmit = (values) => {
    setSubmited(true)
    if (uData != '' && token) {
      if(values.password && values.cpassword){
        setTimeout(() => {
          dispatch(authActions.ChangePassword(values.password,values.cpassword,token,navigate))
          setSubmited(false)
        },1000);
      }else{
        toast.error("password and confirm password fields are required")
        setSubmited(false)
      }
    }else{
      toast.error("Reset password link is expired")
      setSubmited(false)
    }
  };

  const renderForm = (errors, touched) => {
    return <ForgotPasswordForm errors={errors} touched={touched}  submited={submited} />;
  };

  return (
    <div className={`${styles.loginContainer} container-fluid`}>
      <div className="row h-100">
        <div
          className={`${styles.signInPage} col-md-6 d-flex justify-content-center`}
        >
          <img
            src={logo}
            alt="ATS Logo"
            className={`${styles.signInLogo} position-absolute`}
          />
          <Form
            initialValues={initialValues}
            validationSchema={ForgotSchema}
            handleSubmit={handleSubmit}
            renderForm={renderForm}
          />
        </div>
        <div className={`${styles.rightBgImage} col-6 d-none d-md-flex`}>
          <img src={rightImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
